<div style="padding:2rem; display: flex; flex-direction: column; justify-content: space-between">
  <ng-container *ngIf="!(isEnd$ | async) else end" >
    <h2 mat-dialog-title >Elimina account</h2>
    <div>
      <div>
        <p>Sei sicuro di voler eliminare il tuo account?</p>
        <p>Questa operazione è irreversibile</p>
      </div>
    </div>
    <br>
    <br>
    <div>
      <div style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center; width: 100%;">
        <button
          class="btn btn-polstar btn-gradient-orange"
          (click)="delete_user()"
        >Elimina Account</button>
      </div>
    </div>
  </ng-container>

  <ng-template #end>
    <h2 mat-dialog-title >Account eliminato</h2>
    <div>
      <div >
        <p>il tuo account è stato eliminato</p>
      </div>
    </div>
    <br>
    <br>
    <div>
      <div style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center; width: 100%;">
        <button
          class="btn btn-polstar btn-gradient-orange"
          (click)="close()"
        >Chiudi</button>
      </div>
    </div>
  </ng-template>
</div>
